import { onboarding } from '@services';

export interface IFileUploadInvoice {
  studioId: string;
  studioName: string;
  email: string;
  userName: string;
  file?: File;
}

const fileUploadInvoice = async ({
  file,
  studioId,
  email,
  studioName,
  userName,
}: IFileUploadInvoice) => {
  const formData = new FormData();

  if (file) formData.append('file', file);
  if (studioId) formData.append('studioId', studioId);
  if (email) formData.append('email', email);
  if (userName) formData.append('userName', userName);
  if (studioName) formData.append('studioName', studioName);

  await onboarding.post('/api/v1/textract/upload/invoice', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export { fileUploadInvoice };
